<template>
  <AuthLayout center>
    <LoginForm slot="form" />
    <AuthLeftContent slot="content" />
  </AuthLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import AuthLayout from '@/components/auth/AuthLayout'
import AuthLeftContent from '@/components/auth/AuthLeftContent'
import LoginForm from '@/components/auth/LoginForm'

export default {
  components: {
    AuthLayout,
    AuthLeftContent,
    LoginForm
  },
  computed: mapGetters(['isLogged', 'user']),
  async created () {
    if (this.isLogged) {
      await this.getSchoolPackageJoinedById({
        studentId: this.user.id
      })
      if (localStorage.getItem('userType') === 'student') {
        if (this.user.get('getStartedDone')) {
          this.$router.push({ name: 'StudentDashboard' })
        } else {
          this.$router.push({ name: 'StudentDashboard' })
          /** In case of Pre-paid packagee purchase
           * Disabling the Get Started Page
           */
          // this.$router.push({ name: 'GetStarted' })
        }
      } else {
        this.$router.push({ name: 'Dashboard' })
      }
    }
  }
}
</script>
